import regionService from '../../services/ClassenService/modules/regionService';

const state = {
  regions: [],
};

const getters = {
  getRegions() {
    return state.regions;
  },
};

const mutations = {
  SET_REGIONS: (state, regions) => {
    state.regions = regions;
  },

  ADD_REGION: (state, region) => {
    state.regions.push(region);
  },
};

const actions = {
  getRegions: (context) => {
    if (context.state.regions.length === 0) {
      context.commit('SET_REGIONS', ["loading"]);
      regionService.getRegions().then((response) => {
        response.data.forEach((region) => {
          region.selected = false;
          return region;
        });
        context.commit('SET_REGIONS', response.data)
      });
    }
    return context.state.regions
  },

  getRegion: ({commit}, regionId) => new Promise((resolve, reject) => {
    regionService.getRegion(regionId)
      .then((response) => resolve(response))
      .catch((error) => reject(error));
  }),

  addRegion: ({commit}, regionData) => new Promise((resolve, reject) => {
    regionService.addRegion(regionData)
      .then((response) => resolve(response))
      .catch((error) => reject(error));
  }),
};

export default {
  state, mutations, getters, actions,
};
